import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import {
    MagicConfigMixin,
    cdnService,
    formatCurrency,
} from '@gig/magic-common';
import { Currency } from '@gig/magic-sdk/dist/adapter/users/signup';
@Component({
    name: 'loyalty-reward',
    filters: {
        formatCurrency,
    },
})
export default class LoyaltyExchange extends Mixins(MagicConfigMixin) {
    /**
     * Value achievable with this reward
     */
    @Prop(Number) cashValue!: number;

    /**
     * Value of virtual currency needed to buy this reward
     */
    @Prop(Number) coinsValue!: number;

    /**
     * Amount of free spins
     */
    @Prop(Number) spinsNumber!: number;

    /**
     * Boolean to enable/disable exchange button
     */
    @Prop(Boolean) isExchangeable!: boolean;

    /**
     * Reward image config object
     */
    @Prop(Object) icon!: { [key: string]: string };

    /**
     * User's currency
     */
    @Prop(String) currency!: Currency;

    /**
     * Emitted when user decides to exchange a reward
     */
    @Emit('exchangeClicked')
    emitExchangeClicked() {
        return null;
    }

    exchangeClicked() {
        if (!this.isExchangeable) {
            return;
        }
        this.emitExchangeClicked();
    }

    get formattedCashValue() {
        if (!this.$options.filters || !this.$options.filters.formatCurrency) {
            return '';
        }
        return this.$options.filters.formatCurrency(this.cashValue, this.currency, 0);
    }

    getImage(retina: boolean = false) {
        if (!this.icon) {
            return '';
        }

        const lang = this.magicConfig.language;
        const path = this.icon[lang] ? this.icon[lang] : this.icon.en || '';

        return cdnService.getRewardsImageUrl(path, {
            quality: 100,
            retina,
        });
    }
}
